import Quill from "quill";

const Inline = Quill.import("blots/inline") as any;

class CommentBlot extends Inline {
  static blotName = "comment";
  static tagName = "span";
  static className = "ql-comment";

  static create(value: string) {
    const node = super.create();
    node.setAttribute("data-comment-id", value);
    return node;
  }

  static formats(node: HTMLElement) {
    const value = node.getAttribute("data-comment-id");
    return value ? +value : undefined;
  }
}

Quill.register(CommentBlot);